const storageKey = 'political-match-user-photo:v1';

function getLocalStorage(): Storage | null {
  if (typeof window === 'undefined') {
    return null;
  }

  try {
    return window.localStorage;
  } catch {
    return null;
  }
}

function normalizePhotoUrl(photoUrl: string | null | undefined): string | null {
  const normalized = photoUrl?.trim() ?? '';

  return normalized.length > 0 ? normalized : null;
}

export function loadPoliticalMatchUserPhoto(): string | null {
  const storage = getLocalStorage();

  if (!storage) {
    return null;
  }

  try {
    return normalizePhotoUrl(storage.getItem(storageKey));
  } catch {
    return null;
  }
}

export function savePoliticalMatchUserPhoto(photoUrl: string | null | undefined): void {
  const storage = getLocalStorage();

  if (!storage) {
    return;
  }

  const normalized = normalizePhotoUrl(photoUrl);

  try {
    if (!normalized) {
      storage.removeItem(storageKey);
      return;
    }

    storage.setItem(storageKey, normalized);
  } catch {
    // Ignore quota/private mode failures.
  }
}

export function clearPoliticalMatchUserPhoto(): void {
  const storage = getLocalStorage();

  if (!storage) {
    return;
  }

  try {
    storage.removeItem(storageKey);
  } catch {
    // Ignore storage failures.
  }
}
